import Phaser from 'phaser';
import { LOGICAL_BOARD_SIZE } from '../game/content/data';
import type { GameController } from '../app/GameController';
import { setController } from './bridge';
import { BootScene } from './scenes/BootScene';
import { BattleScene } from './scenes/BattleScene';

export const createPhaserGame = (host: HTMLElement, controller: GameController): Phaser.Game => {
  setController(controller);
  return new Phaser.Game({
    type: Phaser.CANVAS,
    parent: host,
    width: LOGICAL_BOARD_SIZE,
    height: LOGICAL_BOARD_SIZE,
    backgroundColor: '#101820',
    render: { antialias: false, pixelArt: true, roundPixels: true },
    scale: { mode: Phaser.Scale.NONE, width: LOGICAL_BOARD_SIZE, height: LOGICAL_BOARD_SIZE },
    scene: [BootScene, BattleScene],
  });
};
